<!--
 * @Description: 原物料运输结算
 * @Author: wangwangwang
 * @Date: 2020-09-21 14:09:06
 * @LastEditors: hexy
 * @LastEditTime: 2024-12-12 15:33:06
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>

      <el-main>
        <!-- 导航 -->
        <div class="tabtop">
          <div v-for="(item, index) in navlist" :key="index" @click="choose(item.id)">
            <div :class="currenindex == index + 1 ? 'active' : 'text'">{{ item.value }}</div>
            <div v-if="currenindex !== index + 1 && currenindex !== index + 2 && index !== 2" class="hr"></div>
          </div>
        </div>
        <!-- 搜索条件 -->
        <div v-loading="pagesLoading">
          <!-- 折叠 -->
          <div class="header_right" @click="showCardNav = !showCardNav">
            <div class="title">搜索</div>
            <div>
              <transition name="from"></transition>
              <span v-show="!showCardNav">
                <i style="margin-right: 5px" class="el-icon-arrow-down"></i>
              </span>
              <transition name="to"></transition>
              <span v-show="showCardNav">
                <i style="margin-right: 5px" class="el-icon-arrow-up"></i>
              </span>
            </div>
          </div>
          <div v-show="showCardNav" class="hr"></div>
          <!-- 搜索内容 -->
          <el-collapse-transition>
            <div v-show="showCardNav" style="padding-top:18px">
              <el-form :inline="true" label-width="110px">
                <!-- 搜索条件1 -->
                <el-form-item v-if="currenindex == 1 || currenindex == 2" label-width="160px">
                  <span slot="label">原物料运输供应商</span>
                  <div style="width:240px;height:36px;display:flex;">
                    <div :title="searchText"
                      style="width:180px;padding:0 10px;border-bottom: 1px solid #bbb;margin-right:5px;" class="ellipsis">
                      {{ searchText }}</div>
                    <el-button class="bottom_all_two" @click="getsearchData(), search = true">选择</el-button>
                  </div>
                </el-form-item>
                <el-form-item v-if="currenindex == 1 || currenindex == 2">
                  <span slot="label">结算时间段</span>
                  <el-date-picker v-model="datePicker" style="height:36px" type="datetimerange" unlink-panels
                    align="right" start-placeholder="开始时间" end-placeholder="结束时间" :default-time="['00:00:00', '23:59:59']"
                    value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </el-form-item>
                <!-- 搜索条件2 -->
                <!-- <el-form-item v-if="currenindex==2">
                  <span slot="label">运输供应商</span>
                  <el-select v-model="tableParam.tranSupplierId" placeholder="请选择">
                    <el-option v-for="(item,index) in unitIdList" :key='index' :label="item.tranSupplier" :value="item.tranSupplierId"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="currenindex==2">
                  <span slot="label">运输物料</span>
                  <el-select v-model="tableParam.rawNameId" placeholder="请选择">
                    <el-option v-for="(item,index) in rawList" :key='index' :label="item.rawName" :value="item.rawNameId"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="currenindex==2">
                  <span slot="label">结算单号</span>
                  <el-input v-model="tableParam.statementNo" placeholder="请输入" clearable></el-input>
                </el-form-item>
                <el-form-item v-if="currenindex==2">
                  <span slot="label">收货时间段</span>
                  <el-date-picker v-model="datePicker" style="height:36px" type="datetimerange" unlink-panels align="right" start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['12:00:00', '08:00:00']" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </el-form-item> -->
                <!-- 搜索条件3 -->
                <el-form-item v-if="currenindex == 3">
                  <span slot="label">结算单号</span>
                  <el-input v-model="tableParam.statementNo" placeholder="请输入" clearable></el-input>
                </el-form-item>
                <el-form-item v-if="currenindex == 3">
                  <span slot="label">运输供应商</span>
                  <el-select v-model="tableParam.unitId" placeholder="请选择">
                    <el-option v-for="(item, index) in unitIdList" :key='index' :label="item.unitName"
                      :value="item.unitId"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="currenindex == 3">
                  <span slot="label">提交时间</span>
                  <el-date-picker v-model="datePicker" style="height:36px" type="datetimerange" unlink-panels
                    align="right" start-placeholder="开始时间" end-placeholder="结束时间" :default-time="['12:00:00', '08:00:00']"
                    value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button v-if="currenindex == 1 || currenindex == 2" icon="el-icon-search" size="medium"
                    class="bottom_all" @click="(tableParam.page = 1), pagesgettableData()">查 询</el-button>
                  <el-button v-else icon="el-icon-search" size="medium" class="bottom_all"
                    @click="(tableParam.page = 1), gettableData()">查 询</el-button>
                  <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重
                    置</el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-collapse-transition>
          <div class="hr"></div>
          <!-- 页面内容区 -->
          <div class="card" :style="currenindex !== 1 ? 'padding-top:10px' : ''">
            <!-- 页面功能按钮区 -->
            <div v-show="currenindex == 1" class=" card_nav">
              <div>
                <el-button v-if="ButtonList.findIndex(res => (res.buttonValue == 'SHENGCJSD')) !== -1" size="small"
                  class="bottom_three" :disabled="generate.originalList.length == 0" @click="statements()">
                  生成结算单
                </el-button>
              </div>
              <div>
              </div>
            </div>
            <!-- 表格数据 -->
            <div v-loading="tableLoading" class="card_info" :style="style">
              <el-table ref="table" :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }"
                border stripe style="width: 100%" :data="tableData" tooltip-effect="dark" @selection-change="tableChange">
                <el-table-column v-if="currenindex == 1" align="center" type="selection"></el-table-column>
                <template v-for="(item, index2) in table">
                  <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center"
                    :min-width="item.width" :fixed="item.label == '操作' ? 'right' : false">
                    <template slot-scope="scope">
                      <span v-if="item.label == '结算时间段'">
                        {{ scope.row.startTime }}至{{ scope.row.endTime }}
                      </span>
                      <div v-else-if="item.label == '结算单号'" class="table_link" @click="show(scope.row)">
                        {{ scope.row[item.prop] }}
                      </div>
                      <span v-else-if="item.label == '序号'">
                        {{ scope.$index + 1 }}
                      </span>
                      <span v-else-if="item.label == '内部审核状态'">
                        {{ scope.row.auditStatus == 1 ? '待提交' : scope.row.auditStatus == 2 ? '审核中' : scope.row.auditStatus == 3 ? '通过' : '未通过' }}
                      </span>
                      <span v-else-if="item.label == '操作'">
                        <el-button v-if="scope.row.auditStatus == 3" size="mini" class="bottom_all_two"
                          @click="userSubmit(scope.row)">
                          发送
                        </el-button>
                        <el-button v-if="scope.row.auditStatus == 1" size="mini" class="bottom_all_two"
                          @click="$router.push({ name: 'sign_Wise_rentunit1', query: { id: scope.row.statementNo, type: 1 } })">提交审核</el-button>
                      </span>
                      <span v-else-if="item.label == '供应商确认'">
                        {{ scope.row.supplierConfirm == 1 ? '待查看' : scope.row.supplierConfirm == 2 ? '通过' : '未发送' }}
                      </span>
                      <span v-else>{{ scope.row[item.prop] }}</span>
                    </template>
                  </el-table-column>
                </template>
              </el-table>
            </div>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination :current-page.sync="tableParam.page" :page-size="tableParam.pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000, '全部']" layout="prev,pager,slot,next,jumper"
            :total="total" @size-change="sizeChange" @current-change="pagesgettableData()">
            <el-select v-model="curElPage" class="pageSelectContainer" placeholder="请选择" @change="changeSizes">
              <el-option v-for="item in optionsPage" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two"
            @click="pagesgettableData()">刷新</el-button>
        </div>
      </div>
    </el-container>
    <!-- 选择供应商合同 -->
    <el-dialog v-dialogDrag :visible.sync="search" width="1000px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">选择原物料运输供应商</span>
      <div class="search">
        <span style="display: inline-block; margin-bottom: 10px">
          <span style="margin-right: 12px">供应商</span>
          <el-input v-model="supplierNameSearch" style="width: 240px" clearable placeholder="请输入"
            @keyup.enter.native="gettableData()" />
        </span>
        <el-button icon="el-icon-search" size="medium" class="bottom_all" @click="getsearchData()">查 询</el-button>
      </div>
      <div class="dialoginfo">
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          style="width: 100%" :data="searchData" tooltip-effect="dark" @row-click="setradio">
          <el-table-column align="center" label="选择">
            <template slot-scope="scope">
              <el-radio :value="searchradio" :label="JSON.stringify(scope.row)">{{ "" }}</el-radio>
            </template>
          </el-table-column>
          <el-table-column align="center" label="原物料运输合同编号" prop="contractNumber"></el-table-column>
          <el-table-column align="center" label="运输物料名称" prop="cargo"></el-table-column>
          <el-table-column align="center" label="供应商单位" prop="supplierName"></el-table-column>
          <el-table-column align="center" label="合同签订主体" prop="contractSigningSubject"></el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="search = false">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="submitsearch">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 原物料结算单 -->
    <el-dialog v-dialogDrag :visible.sync="billDeta" width="1180px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">原物料运输结算单</span>
      <div ref="html" style="padding:10px 20px">
        <div class="bill_top">
          <span><span class="text">运输供应商：</span>{{ billDetails.supplyName }}</span>
          <span><span class="text">合同签订主体：</span>{{ billDetails.contractSigningSubject }}</span>
          <span><span class="text">结算时间段：</span>{{ billDetails.startTime }}至{{ billDetails.endTime }}</span>
          <span><span class="text">结算单编号：</span>{{ billDetails.statementNo }}</span>
        </div>
        <div style="padding:10px 0">
          <span v-if="UserInfo.adminStatus == 1" style="color: #ff0000">公司</span>
          <el-select v-if="UserInfo.adminStatus == 1" ref="selection1" v-model="companyId"
            style="padding-left:15px;padding-right:40px"
            @change="setstationIdlist(), $nextTick(() => { company = $refs.selection1.selectedLabel })">
            <el-option v-for="item in companylist" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <!-- <span style="color: #ff0000">站点名称</span>
          <el-select ref="selection2" v-model="stationId" style="padding-left:15px" @change="get_simple_organizationFun(stationId),$nextTick(()=>{stationName = $refs.selection2.selectedLabel})">
            <el-option v-for="item in stationIdlist" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select> -->
        </div>
        <div class="bill_title1" style="padding-bottom: 15px">结算信息</div>
        <template v-for="(item, index) in billList">
          <div :key="index">
            <div class="bill_subtitle">
              <span><span class="text">供应商：</span>{{ item.tranSupplier }}</span>
              <span><span class="text">结算物料：</span>{{ item.rawName }}</span>
            </div>
            <el-table v-if="settleType == 0" :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
              style="width: 100%" :data="item.list" tooltip-effect="dark">
              <el-table-column label="时间段" align="center" width="175">
                <template slot-scope="scope"> {{ scope.row.carStartTime }}至{{ scope.row.carEndTime }} </template>
              </el-table-column>
              <el-table-column label="站点" align="center" prop="receiveStation"></el-table-column>
               <!-- 量价结算显示 开始 -->
                <el-table-column  label="基础单价(元/吨)" align="center" prop="price"></el-table-column>
                <el-table-column label="收货量（吨）" align="center" prop="receiveNum"></el-table-column>
                <el-table-column  label="结算单价(元/吨)" align="center">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.settlementPrice" type="Number" style="width:100%" placeholder="请输入"
                      clearable></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="结算量（吨）" align="center" width="120">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.statementNum" placeholder="请输入" style="width: 100%"
                      onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="应付金额（元）" align="center" prop="dealPrice" width="120">
                  <template slot-scope="scope">
                    {{ (scope.row.dealPrice = Math.round($regExp.FloatMul(scope.row.settlementPrice,
                      scope.row.statementNum) * 100) / 100) }}
                  </template>
                </el-table-column>
                <el-table-column label="结算金额（元）" align="center" prop="">
                <template slot-scope="scope">
                  {{ (scope.row.realPay = Math.round(parseFloat(Number(scope.row.dealPrice) +
                    Number(scope.row.increaseAmount)) * 100) / 100) }}
                </template>
              </el-table-column>
              <!-- 量价结算显示 结束 -->
              <el-table-column label="增加金额（元）" align="center" width="120">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.increaseAmount" placeholder="请输入" style="width: 100%"
                    onkeypress="return (/[\d\.\-]/.test(String.fromCharCode(event.keyCode)));"
                    @input="scope.row.increaseAmount = $regExp.checkNum(scope.row.increaseAmount)"
                    @blur="scope.row.increaseAmount = $regExp.blurCheckNum(scope.row.increaseAmount,true)"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="增加金额备注" align="center" width="220">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.remark" placeholder="请输入" style="width: 100%"></el-input>
                </template>
              </el-table-column>
            </el-table>
            <el-table v-if="settleType == 1" :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
              style="width: 100%" :data="item.list" tooltip-effect="dark">
              <el-table-column label="站点" align="center" prop="receiveStation"></el-table-column>
              <!-- 量差结算显示 -->
                <el-table-column  label="运输单价（元/吨）" align="center" prop="price"></el-table-column>
                <el-table-column  label="产品单价（元/吨）" align="center" prop="productPrice"></el-table-column>
                <el-table-column  label="审核量（吨）" align="center" prop="receiveNum"></el-table-column>
                <el-table-column  label="毛重（吨）" align="center" prop="firstWeight"></el-table-column>
                <el-table-column  label="皮重（吨）" align="center" prop="secondWeight"></el-table-column>
                <el-table-column label="扣减量（吨）" align="center" prop="deductionNum"></el-table-column>
                <el-table-column  label="结算金额（元）" align="center" prop="settlementAmount"></el-table-column>
                <!-- 量差结算显示 结束-->
              <el-table-column label="增加金额（元）" align="center" width="120">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.increaseAmount" placeholder="请输入" style="width: 100%"
                    onkeypress="return (/[\d\.\-]/.test(String.fromCharCode(event.keyCode)));"
                    @input="scope.row.increaseAmount = $regExp.checkNum(scope.row.increaseAmount)"
                    @blur="scope.row.increaseAmount = $regExp.blurCheckNum(scope.row.increaseAmount,true)"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="增加金额备注" align="center" width="220">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.remark" placeholder="请输入" style="width: 100%"></el-input>
                </template>
              </el-table-column>
            </el-table>
            <div style="border-top: 0px" class="combined">小计：{{ combined(item.list) }}</div>
          </div>
        </template>
        <!-- 结算补差 -->
        <div v-show="senderDigList.length" class="bill_title">结算补差
          <el-button size="mini" class="bottom_all" style="margin-left: 24px" @click="selectSenders()">
            <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
            选择
          </el-button>
        </div>
        <template v-for="(item, index) in sendersList">
          <div :key="index + '2'">
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border
              :show-header="index == 0" stripe style="width: 100%" :data="item.list" tooltip-effect="dark"
              :span-method="sendersSpanMethod">
              <el-table-column label="供应商" align="center" prop="cooperativeUnit"></el-table-column>
              <el-table-column label="站点" align="center" prop="receiveStation"></el-table-column>
              <el-table-column label="物料名称" align="center" prop="rawName"></el-table-column>
              <el-table-column label="补差日期" align="center">
                <template slot-scope="scope">
                  {{ scope.row.compensateStartTime + "-" + scope.row.compensateEndTime }}
                </template>
              </el-table-column>
              <el-table-column label="补差数量" align="center" prop="compensateNum">
              </el-table-column>
              <el-table-column label="补差单价（元）" align="center" prop="compensatePrice">
              </el-table-column>
              <el-table-column label="补差金额（元）" align="center">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.compensateAmount" placeholder="请输入" style="width: 100%" clearable
                    onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"></el-input>
                </template>
              </el-table-column>
            </el-table>
            <div style="border-top: 0px" class="combined">小计：{{ combined2(item, item.list) }}</div>
          </div>
        </template>
        <!-- 调整金额 -->
        <div class="bill_title">
          调整金额
          <el-button size="mini" class="bottom_all" style="margin-left: 24px" @click="addItem1()">
            <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
            添加
          </el-button>
        </div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          style="width: 100%" :data="deductionList" tooltip-effect="dark">
          <el-table-column label="供应商" align="center" prop="cooperativeUnit">
          </el-table-column>
          <el-table-column label="站点" align="center">
            <template slot-scope="scope">
              <el-select ref="station1" v-model="scope.row.stationId" style="width: 100%" placeholder="请选择站点">
                <el-option v-for="item in stations" :key="item.id" :label="item.name" :value="item.id"
                  @click.native="scope.row.station = item.name"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="原物料" align="center">
            <template slot-scope="scope">
              <el-select ref="station1" v-model="scope.row.rawId" style="width: 100%" placeholder="请选择站点">
                <el-option v-for="item in rawMaterialsList" :key="item.id" :label="item.name" :value="item.id"
                  @click.native="scope.row.rawName = item.name"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="调整类型" align="center">
            <template slot-scope="scope">
              <el-select ref="deductionType1" v-model="scope.row.deductionTypeId" style="width: 100%"
                placeholder="请选择调整类型">
                <el-option v-for="item in deductionTypes" :key="item.id" :label="item.itemName" :value="item.id"
                  @click.native="scope.row.deductionType = item.itemName"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="调增调减" align="center" prop="addOrReduce">
            <template slot-scope="scope">
              <el-select ref="addOrReduce" v-model="scope.row.addOrReduce" style="width: 100%" placeholder="请选择">
                <el-option :key="1" label="调增" :value="1"></el-option>
                <el-option :key="2" label="调减" :value="0"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="调整金额" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.deduction" placeholder="请输入" style="width: 100%"
                onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                @input="scope.row.deduction = $regExp.checkNum(scope.row.deduction)"
                @blur="scope.row.deduction = $regExp.blurCheckNum(scope.row.deduction)"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="是否影响开票" align="center">
            <template slot-scope="scope">
              <el-radio-group v-model="scope.row.influenceInvoice">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </template>
          </el-table-column>
          <el-table-column label="备注" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.remark" placeholder="请输入" style="width: 100%" clearable></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="left" width="120">
            <template slot-scope="scope">
              <el-button size="mini" class="bottom_two" @click="delItem1(scope.$index)">
                <i class="icon iconfont iconicon_button_delete" style="font-size: 12px"></i>
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="bill_title">结算合计</div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          style="width: 100%" :data="totalList" tooltip-effect="dark">
          <el-table-column label="供应商" align="center" prop="tranSupplier"></el-table-column>
          <el-table-column label="待结算金额（元）" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.settlementAmount }}</div>
            </template>
          </el-table-column>
          <el-table-column label="补差金额（元）" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.compensateAmount }}</div>
            </template>
          </el-table-column>
          <el-table-column label="调整金额（元）" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.deduction }}</div>
            </template>
          </el-table-column>
          <!-- <el-table-column label="收获量(吨)" align="center" prop="receiveNum"></el-table-column> -->
          <el-table-column label="结算金额 (元)" align="center" prop="realPay"></el-table-column>
          <el-table-column label="开票金额（元）" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.faceAdjustment" placeholder="请输入" style="width: 100%"
                onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                @input="scope.row.faceAdjustment = $regExp.checkNum(scope.row.faceAdjustment)"
                @blur="scope.row.faceAdjustment = $regExp.blurCheckNum(scope.row.faceAdjustment)"></el-input>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer" style="display:flex;justify-content: space-between;">
        <div>
          <el-button class="bottom_all_two" @click="downloadLink">打印结算单</el-button>
          <el-button class="bottom_all_two" @click="combinedSubmit(2)">提交审核</el-button>
        </div>
        <div>
          <el-button class="bottom_all_two" @click="billDeta = false">关闭</el-button>
          <el-button class="bottom_all" style="margin-left: 24px" @click="combinedSubmit(1)">保 存</el-button>
        </div>

      </span>
    </el-dialog>
    <!-- 查看结算单 -->
    <el-dialog v-dialogDrag :visible.sync="billDeta1" width="1180px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">原物料运输结算单</span>
      <div ref="html" style="padding:10px 20px">
        <!-- <div class="bill_top">
          <span><span class="text">客户名称：</span>{{billDetails1.unitName}}</span>
          <span><span class="text">公司：</span>{{billDetails1.company}}</span>
          <span><span class="text">站点名称：</span>{{billDetails1.stationName}}</span>
          <span><span class="text">结算时间：</span>{{billDetails1.startTime}}至{{billDetails1.endTime}}</span>
          <span><span class="text">结算单编号：</span>{{billDetails1.statementNo}}</span>
        </div> -->
        <div class="bill_top">
          <span><span class="text">运输供应商：</span>{{ billDetails1.supplyName }}</span>
          <span><span class="text">运输供应商：</span>{{ billDetails1.contractSigningSubject }}</span>
          <span><span class="text">结算时间段：</span>{{ billDetails1.startTime }}至{{ billDetails1.endTime }}</span>
          <span><span class="text">结算单编号：</span>{{ billDetails1.statementNo }}</span>
        </div>
        <div class="bill_title1" style="padding-bottom: 15px">结算信息</div>
        <template v-for="(item, index) in billList">
          <div :key="index">
            <div class="bill_subtitle">
              <span><span class="text">供应商：</span>{{ item.tranSupplier }}</span>
              <span><span class="text">结算物料：</span>{{ item.rawName }}</span>
            </div>
            <el-table v-if="settleType == 0" :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
              style="width: 100%" :data="item.list" tooltip-effect="dark">
              <el-table-column label="站点" align="center" prop="receiveStation"></el-table-column>
              <el-table-column label="基础单价(元/吨)" align="center" prop="price"></el-table-column>
              <el-table-column label="收货量（吨）" align="center" prop="receiveNum"></el-table-column>
              <el-table-column label="结算单价(元/吨)" align="center">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.settlementPrice" :disabled="low.auditStatus != 1" type="Number"
                    style="width:100%" placeholder="请输入" clearable></el-input>
                </template>
              </el-table-column>
              <el-table-column label="结算量（吨）" align="center" width="120">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.statementNum" :disabled="low.auditStatus != 1" placeholder="请输入"
                    style="width: 100%" onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="应付金额（元）" align="center" prop="dealPrice" width="120">
                <template slot-scope="scope">
                  {{ (scope.row.dealPrice = Math.round($regExp.FloatMul(scope.row.settlementPrice,
                    scope.row.statementNum) * 100) / 100) }}
                </template>
              </el-table-column>
              <el-table-column label="增加金额（元）" align="center" width="120">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.increaseAmount" placeholder="请输入" :disabled="low.auditStatus != 1"
                    style="width: 100%" onkeypress="return (/[\d\.\-]/.test(String.fromCharCode(event.keyCode)));"
                    @input="scope.row.increaseAmount = $regExp.checkNum(scope.row.increaseAmount)"
                    @blur="scope.row.increaseAmount = $regExp.blurCheckNum(scope.row.increaseAmount,true)"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="结算金额（元）" align="center" prop="">
                <template slot-scope="scope">
                  {{ (scope.row.realPay = Math.round(parseFloat(Number(scope.row.dealPrice) +
                    Number(scope.row.increaseAmount)) * 100) / 100) }}
                </template>
              </el-table-column>
              <el-table-column label="增加金额备注" align="center" width="220">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.remark" :disabled="low.auditStatus != 1" placeholder="请输入"
                    style="width: 100%"></el-input>
                </template>
              </el-table-column>
            </el-table>
            <el-table v-if="settleType == 1" :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
              style="width: 100%" :data="item.list" tooltip-effect="dark">
              <el-table-column label="站点" align="center" prop="receiveStation"></el-table-column>
              <!-- 量差结算显示 -->
                <el-table-column  label="运输单价（元/吨）" align="center" prop="price"></el-table-column>
                <el-table-column  label="产品单价（元/吨）" align="center" prop="productPrice"></el-table-column>
                <el-table-column  label="审核量（吨）" align="center" prop="receiveNum"></el-table-column>
                <el-table-column  label="毛重（吨）" align="center" prop="firstWeight"></el-table-column>
                <el-table-column  label="皮重（吨）" align="center" prop="secondWeight"></el-table-column>
                <el-table-column label="扣减量（吨）" align="center" prop="deductionNum"></el-table-column>
                <el-table-column  label="结算金额（元）" align="center" prop="settlementAmount"></el-table-column>
                <!-- 量差结算显示 结束-->
              <el-table-column label="增加金额（元）" align="center" width="120">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.increaseAmount" placeholder="请输入" :disabled="low.auditStatus != 1" style="width: 100%"
                    onkeypress="return (/[\d\.\-]/.test(String.fromCharCode(event.keyCode)));"
                    @input="scope.row.increaseAmount = $regExp.checkNum(scope.row.increaseAmount)"
                    @blur="scope.row.increaseAmount = $regExp.blurCheckNum(scope.row.increaseAmount,true)"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="增加金额备注" align="center" width="220">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.remark" :disabled="low.auditStatus != 1" placeholder="请输入" style="width: 100%"></el-input>
                </template>
              </el-table-column>
            </el-table>
            <div style="border-top: 0px" class="combined">小计：{{ combined(item.list) }}</div>
          </div>
        </template>
        <!-- 结算补差 -->
        <div v-show="sendersList.length || (low.auditStatus == 1 && senderDigList.length)" class="bill_title">结算补差
          <el-button v-show="low.auditStatus == 1" size="mini" class="bottom_all" style="margin-left: 24px"
            @click="selectSenders()">
            <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
            选择
          </el-button>
        </div>
        <template v-for="(item, index) in sendersList">
          <div :key="index + '2'">
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border
              :show-header="index == 0" stripe style="width: 100%" :data="item.list" tooltip-effect="dark"
              :span-method="sendersSpanMethod">
              <el-table-column label="供应商" align="center" prop="cooperativeUnit"></el-table-column>
              <el-table-column label="站点" align="center" prop="receiveStation"></el-table-column>
              <el-table-column label="物料名称" align="center" prop="rawName"></el-table-column>
              <el-table-column label="补差日期" align="center">
                <template slot-scope="scope">
                  {{ scope.row.compensateStartTime + "-" + scope.row.compensateEndTime }}
                </template>
              </el-table-column>
              <el-table-column label="补差数量" align="center" prop="compensateNum">
              </el-table-column>
              <el-table-column label="补差单价（元）" align="center" prop="compensatePrice">
              </el-table-column>
              <el-table-column label="补差金额（元）" align="center">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.compensateAmount" :disabled="low.auditStatus != 1" placeholder="请输入"
                    style="width: 100%" clearable
                    onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"></el-input>
                </template>
              </el-table-column>
            </el-table>
            <div style="border-top: 0px" class="combined">小计：{{ combined2(item, item.list) }}</div>
          </div>
        </template>
        <!-- 调整金额 -->
        <div class="bill_title">
          调整金额
          <el-button v-show="low.auditStatus == 1" size="mini" class="bottom_all" style="margin-left: 24px"
            @click="addItem1()">
            <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
            添加
          </el-button>
          <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none', fontWeight: '1' }"
            border stripe style="width: 100%" :data="deductionList" tooltip-effect="dark">
            <el-table-column label="供应商" align="center" prop="cooperativeUnit"></el-table-column>
            <el-table-column label="站点" align="center">
              <template slot-scope="scope">
                <el-select ref="station1" v-model="scope.row.stationId" :disabled="low.auditStatus != 1"
                  style="width: 100%" placeholder="请选择站点">
                  <el-option v-for="item in stations" :key="item.id" :label="item.name" :value="item.id"
                    @click.native="scope.row.station = item.name"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="原物料" align="center">
            <template slot-scope="scope">
              <el-select ref="station1" v-model="scope.row.rawId" style="width: 100%" placeholder="请选择站点">
                <el-option v-for="item in rawMaterialsList" :key="item.id" :label="item.name" :value="item.id"
                  @click.native="scope.row.rawName = item.name"></el-option>
              </el-select>
            </template>
          </el-table-column>
            <el-table-column label="调整类型" align="center">
              <template slot-scope="scope">
                <el-select ref="deductionType1" v-model="scope.row.deductionTypeId" style="width: 100%"
                  :disabled="low.auditStatus != 1" placeholder="请选择调整类型">
                  <el-option v-for="item in deductionTypes" :key="item.id" :label="item.itemName" :value="item.id"
                    @click.native="scope.row.deductionType = item.itemName"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="调增调减" align="center" prop="addOrReduce">
              <template slot-scope="scope">
                <el-select ref="addOrReduce" v-model="scope.row.addOrReduce" style="width: 100%"
                  :disabled="low.auditStatus != 1" placeholder="请选择">
                  <el-option :key="1" label="调增" :value="1"></el-option>
                  <el-option :key="2" label="调减" :value="0"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="调整金额" align="center">
              <template slot-scope="scope">
                <el-input v-model="scope.row.deduction" placeholder="请输入" :disabled="low.auditStatus != 1"
                  style="width: 100%" onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                  @input="scope.row.deduction = $regExp.checkNum(scope.row.deduction)"
                  @blur="scope.row.deduction = $regExp.blurCheckNum(scope.row.deduction)"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="是否影响开票" align="center">
              <template slot-scope="scope">
                <el-radio-group v-model="scope.row.influenceInvoice" :disabled="low.auditStatus != 1">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </template>
            </el-table-column>
            <el-table-column label="备注" align="center">
              <template slot-scope="scope">
                <el-input v-model="scope.row.remark" placeholder="请输入" style="width: 100%" clearable></el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="left" width="120">
              <template slot-scope="scope">
                <el-button size="mini" class="bottom_two" @click="delItem1(scope.$index)">
                  <i class="icon iconfont iconicon_button_delete" style="font-size: 12px"></i>
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="bill_title">结算合计</div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          style="width: 100%" :data="totalList" tooltip-effect="dark">
          <el-table-column label="供应商" align="center" prop="tranSupplier"></el-table-column>
          <el-table-column label="待结算金额（元）" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.settlementAmount }}</div>
            </template>
          </el-table-column>
          <el-table-column label="补差金额（元）" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.compensateAmount }}</div>
            </template>
          </el-table-column>
          <el-table-column label="调整金额（元）" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.deduction }}</div>
            </template>
          </el-table-column>
          <!-- <el-table-column label="收获量(吨)" align="center" prop="receiveNum"></el-table-column> -->
          <el-table-column label="结算金额 (元)" align="center" prop="realPay"></el-table-column>
          <el-table-column label="开票金额（元）" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.faceAdjustment" placeholder="请输入" style="width: 100%"
                :disabled="low.auditStatus != 1" onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                @input="scope.row.faceAdjustment = $regExp.checkNum(scope.row.faceAdjustment)"
                @blur="scope.row.faceAdjustment = $regExp.blurCheckNum(scope.row.faceAdjustment)"></el-input>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer" style="display:flex;justify-content: space-between;">
        <div>
          <el-button class="bottom_all_two" @click="downloadLink">打印结算单</el-button>
        </div>
        <div>
          <el-button class="bottom_all_two" @click="billDeta1 = false">取 消</el-button>
          <el-button v-if="low.auditStatus == 1" class="bottom_all" style="margin-left: 24px"
            @click="combinedSubmit_3()">保 存</el-button>
        </div>

      </span>
    </el-dialog>
    <!--选择发送的人员-->
    <!-- <el-dialog v-dialogDrag :visible.sync="userDeta" width="620px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">请选择接收账号</span>
      <div style="padding:0 10px">
        <el-checkbox-group v-model="userarr">
          <template v-for="(item,index) in useroptons">
            <el-checkbox :key="index" style="line-height:26px" :label="item.id">{{item.name}}</el-checkbox>
          </template>
        </el-checkbox-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="userDeta=false">取 消</el-button>
        <el-button class="bottom_all" :disabled="userarr.length==0" style="margin-left: 24px" @click="userSubmit()">发 送</el-button>
      </span>
    </el-dialog> -->
    <!-- 选择补差 -->
    <el-dialog :visible.sync="sendersDig" width="960px" :close-on-click-modal="false" :append-to-body="true">
      <span slot="title" class="dialog-title">结算补差选择</span>
      <div class="dialoginfo">
        <el-table ref="senderDigTable" :header-cell-style="{ background: '#f3f6f9' }"
          :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="senderDigList"
          tooltip-effect="dark" :row-key="getRowKeys" @selection-change="changeSenders">
          <el-table-column type="selection" :reserve-selection="true" width="55"> </el-table-column>
          <el-table-column label="供应商" align="center" prop="cooperativeUnit"></el-table-column>
          <el-table-column label="站点" align="center" prop="receiveStation"></el-table-column>
          <el-table-column label="物料名称" align="center" prop="rawName"></el-table-column>
          <el-table-column label="补差日期" align="center">
            <template slot-scope="scope">
              {{ scope.row.compensateStartTime + "-" + scope.row.compensateEndTime }}
            </template>
          </el-table-column>
          <el-table-column label="补差数量" align="center" prop="compensateNum"></el-table-column>
          <el-table-column label="补差单价（元）" align="center" prop="compensatePrice"></el-table-column>
          <el-table-column label="补差金额（元）" align="center">
            <template slot-scope="scope">{{ Number(Number(scope.row.compensatePrice) *
              Number(scope.row.compensateNum)).toFixed(2) }}</template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="(sendersDig = false)">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="confirmSenders">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import mixin from "@/mixins/ICPSmixin.js";
import {
  get_contract_list,
  queryPage1,
  generate_statement,
  save_or_update_detail,
  get_supplier_list,
  queryPage3,
  //queryPage2,
  //get_search_conditions,
  get_statement_detail,
  update_status,
  Download,
  generate_tansport_tatement_compensate,
  update_statement
} from "@/api/wise/Wise_rentunit/Wise_rentunit1.js";
import { _debounce } from '@/utils/utils.js'
import { getUserInfo } from "@/utils/auth.js";
import {
  getcompany, getUserAutList, get_simple_organization,
  uploadFile
} from "@/api/common.js";
import { get_station_list } from "@/api/smart/stocksake.js";
import html2canvas from 'html2canvas';
import { getDicType } from "@/api/common.js";
import {
  // queryUserByID,
  informClient
} from "@/api/wise/Wise_contactsbusiness/Wise_contactsbusiness.js";
export default {
  mixins: [mixin],
  data() {
    return {
      //分页
      optionsPage: [
        {
          label: "10条/页",
          value: 10,
        },
        {
          label: "20条/页",
          value: 20,
        },
        {
          label: "30条/页",
          value: 30,
        },
        {
          label: "40条/页",
          value: 40,
        },
        {
          label: "50条/页",
          value: 50,
        },
        {
          label: "100条/页",
          value: 100,
        },
        {
          label: "200条/页",
          value: 200,
        },
        {
          label: "500条/页",
          value: 500,
        },
        {
          label: "1000条/页",
          value: 1000,
        },
        {
          label: "全部",
          value: 100000,
        },
      ],
      curElPage: 100000, //默认每页显示20条
      supplierNameSearch: "", //供应商弹窗筛选
      UserInfo: '',
      companyId: '',
      company: '',
      companylist: [],
      stationId: '',
      stationName: '',
      stationIdlist: [],
      pagesLoading: false,
      /*表格增删改查及下载接口*/
      queryPage: '',
      download: Download,
      /*表格数据*/
      table: [],
      table1: [
        { label: "运输供应商", width: "auto", prop: "tranSupplier", status: true },
        { label: "运输物料", width: "120", prop: "rawName", status: true },
        { label: "运输车辆", width: "auto", prop: "carNo", status: true },
        { label: "原物料供应商", width: "120", prop: "rawSupplierName", status: true },
        { label: "起运地点", width: "auto", prop: "startAddress", status: true },
        { label: "收货站点", width: "120", prop: "receiveStation", status: true },
        { label: "收货量（吨）", width: "auto", prop: "receiveNum", status: true },
        { label: "收货时间", width: "120", prop: "actualReceiveTime", status: true },
        // { label: "单价（元/吨）", width: "120", prop: "price", status: true },
        // { label: "结算金额（元）", width: "120", prop: "settlementAmount", status: true },
      ],
      table2: [
        { label: "运输供应商", width: "auto", prop: "tranSupplier", status: true },
        { label: "运输物料", width: "120", prop: "rawName", status: true },
        { label: "运输车辆", width: "auto", prop: "carNo", status: true },
        { label: "原物料供应商", width: "120", prop: "rawSupplierName", status: true },
        { label: "起运地点", width: "auto", prop: "startAddress", status: true },
        { label: "收货站点", width: "120", prop: "receiveStation", status: true },
        { label: "收货量（吨）", width: "auto", prop: "receiveNum", status: true },
        { label: "收货时间", width: "120", prop: "actualReceiveTime", status: true },
        // { label: "单价（元/吨）", width: "120", prop: "price", status: true },
        // { label: "结算金额（元）", width: "120", prop: "settlementAmount", status: true },
        { label: "结算单号", width: "120", prop: "statementNo", status: true },
      ],
      table3: [
        { label: "序号", width: "50", prop: "", status: true },
        { label: "结算单号", width: "300", prop: "statementNo", status: true },
        { label: "运输供应商", width: "140", prop: "unitName", status: true },
        { label: "合同签订主体", width: "140", prop: "contractSigningSubject", status: true },
        { label: "结算时间段", width: "310", prop: "", status: true },
        { label: "结算总金额（元）", width: "140", prop: "statementAmount", status: true },
        { label: "提交时间", width: "160", prop: "submitTime", status: true },
        { label: "内部审核状态", width: "120", prop: "", status: true },
        { label: "操作", width: "140", prop: "", status: true },
        { label: "供应商确认", width: "120", prop: "", status: true },
      ],
      pagesType: 0,
      /**导航栏*/
      navlist: [
        {
          value: "待结算",
          id: 1,
        },
        {
          value: "已结算",
          id: 2,
        },
        {
          value: "结算单",
          id: 3,
        },
      ],
      currenindex: 1,
      /**时间*/
      datePicker: [],
      /**搜索条件1*/
      searchText: '',
      search: false,
      searchData: [],
      searchradio: [],
      /**生成结算的数据*/
      generate: {
        originalList: [],
        contractId: '',
        startTime: '',
        endTime: '',
        statementNo: ''
      },
      /*结算单详情*/
      billDeta: false,
      billDetails: {},
      billList: [],
      totalList: [],
      unitIdList: [],
      //结算补差-调整开始
      sendersList: [],
      senderDigList: [],
      selectSendersList: [],
      sendersDig: false,
      spanArr: {},
      pos: '',
      deductionList: [],
      deductionListCopy: [],
      //结算补差-调整开始
      rawList: [],
      billDeta1: false,
      billDetails1: {
        list: []
      },
      // totalList1: [
      // ],
      userDeta: false,
      useroptons: [],
      userarr: [],
      low: {},
      deductionTypes: [],
      rawMaterialsList:[],
    };
  },
  async created() {
    const { data } = await getDicType({ code: "deductionType" });
    this.deductionTypes = data.items;
    /*存储拷贝的原初始化fromDate数据*/
    this.UserInfo = getUserInfo();
    if (this.UserInfo.adminStatus == 1) {
      /**通过typeId为公司类型id查询所有公司 */
      getcompany({ typeId: "19da56b9e85648059e3cf1e7da497da4" }).then((res) => {
        this.companylist = res.data;
      });
    } else {
      this.stationIdlist = await getUserAutList(true)
    }
  },
  watch: {
    /**导航切换*/
    currenindex: {
      handler() {
        this.tableData = []
        this.datePicker = []
        this.tableParam = this.$options.data().tableParam
        this.tableParam.pageSize = this.curElPage
        if (this.currenindex == 1) {
          this.searchText = ''
          this.table = this.table1;
          this.tableParam.carContractId = ''
          this.queryPage = queryPage1
          this.tableParam['settlementStatusList'] = [0]
        }
        if (this.currenindex == 2) {
          // this.getsearchData()
          // this.table = this.table2;
          // this.queryPage = queryPage2
          // this.gettableData()
          this.searchText = ''
          this.table = this.table1;
          this.tableParam.carContractId = ''
          this.queryPage = queryPage1
          this.tableParam['settlementStatusList'] = [1, 2]
        }
        if (this.currenindex == 3) {
          this.getsearchData()
          this.table = this.table3;
          this.queryPage = queryPage3
          this.tableParam.statementType = 1
          this.gettableData()
        }
        this.pagesLoading = false
        //此处为执行的函数或者方法
      },
      deep: false,
      immediate: true,
      settleType: '',//0为量价 1为量差
    },
    /**时间选择*/
    datePicker() {
      if (this.datePicker) {
        this.tableParam.startTime = this.datePicker[0]
        this.tableParam.endTime = this.datePicker[1]
      } else {
        this.tableParam.startTime = ''
        this.tableParam.endTime = ''
      }
    },
    /**table1默认全选*/
    tableData() {
      if (this.tableData.length !== 0 && this.currenindex == 1) {
        this.$refs.table.toggleAllSelection()
        this.generate.startTime = this.tableParam.startTime
        this.generate.endTime = this.tableParam.endTime
        this.generate.contractId = this.tableParam.carContractId
        this.generate.unitId = this.searchradio.supplierId
        this.generate.unitName = this.searchradio.supplierName
      }
    },
    /**结算合计*/
    tatol: {
      handler() {
        this.settotalList()
      },
      deep: true,
      immediate: false,
    },
  },
  computed: {
    tatol() {
      return {
        billList: this.billList,
        sendersList: this.sendersList,
        deductionList: this.deductionList,
      };
    },
  },
  methods: {
    /*补差 */
    /**结算补差合计*/
    combined2(item, arr) {
      let num = 0;
      arr.forEach(res => {
        num = Number(res.compensateAmount) + num;
      });
      item["compensateAmount"] = num;
      return num.toFixed(2);
    },
    toggleSelection(rows) {
      if (rows.length > 0) {
        this.$refs.senderDigTable.clearSelection();
        this.selectSendersList = []
        rows.forEach(row => {
          row.detailId.forEach(detail => {
            let oneDetail = this.senderDigList.find(item => {
              return detail === item.detailId
            })
            this.selectSendersList.push(oneDetail)
            this.$refs.senderDigTable.toggleRowSelection(oneDetail, true);
          })

        });
      } else {
        this.$refs.senderDigTable.clearSelection();
      }
    },
    getRowKeys(row) {
      return row.detailId; //一般是你选择项的id
    },
    async selectSenders() {
      this.selectSendersList = []
      let arr = []
      this.sendersDig = true
      setTimeout(() => {
        this.sendersList?.forEach(item => {
          arr = [...arr, ...item.list]
        })
        this.toggleSelection(arr)
      }, 500)
    },
    changeSenders(val) {
      this.selectSendersList = []
      this.selectSendersList = val
    },
    confirmSenders() {
      this.sendersList = []
      this.selectSendersList.sort((a, b) => {
        return b.rawId - a.rawId;
      });
      let copySelectSendersList = JSON.parse(JSON.stringify(this.selectSendersList))
      let sumSendersList = copySelectSendersList.reduce((pre, cur) => {
        let sameType = false
        if (pre.length == 0) {
          let detailId = cur.detailId
          cur.detailId = []
          cur.detailId.push(detailId)
          pre.push(cur)
        } else {
          pre.forEach(item => {
            if (item.receiveStationId == cur.receiveStationId && item.cooperativeUnitId == cur.cooperativeUnitId && item.rawId == cur.rawId && item.compensateStartTime == cur.compensateStartTime && item.compensateEndTime == cur.compensateEndTime && item.compensatePrice == cur.compensatePrice) {
              sameType = true
              item.compensateNum = Number(item.compensateNum * 1 + cur.compensateNum * 1).toFixed(2)
              item.detailId.push(cur.detailId)
            }
          })
          if (!sameType) {
            let detailId = cur.detailId
            cur.detailId = []
            cur.detailId.push(detailId)
            pre.push(cur)
          }
        }
        return pre
      }, [])
      sumSendersList.forEach(val => {
        val.compensateAmount = Number(Number(val.compensatePrice) * Number(val.compensateNum)).toFixed(2)
        let index = this.sendersList.findIndex(item => item.cooperativeUnitId == val.cooperativeUnitId);
        console.log(index)
        if (index == -1) {
          let arr = [];
          arr.push(val);
          this.sendersList.push({ cooperativeUnit: val.cooperativeUnit, cooperativeUnitId: val.cooperativeUnitId, list: arr });
        } else {
          this.sendersList[index].list.push(val);
        }
      });
      this.getSpanArr(this.sendersList)
      this.sendersDig = false
    },
    /* */
    sendersSpanMethod({ row, rowIndex, columnIndex }) {
      if (columnIndex == 0) {
        const _row = this.spanArr[row.cooperativeUnitId][rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col
        };
      }
      if (columnIndex == 1) {
        console.log(this.spanArr)
        console.log(rowIndex)
        const _row = this.spanArr[row.receiveStationId + 'station' + row.cooperativeUnitId][rowIndex];
        console.log('----------------', _row)
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col
        };
      }
      if (columnIndex == 2) {
        const _row = this.spanArr[row.receiveStationId + 'station' + row.cooperativeUnitId + 'rawId' + row.rawId][rowIndex];
        console.log('----------------', _row)
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col
        };
      }
    },
    getSpanArr(data) {
      if (data.length == 0) {
        return
      }
      console.log("zmmm--", data)//从后台获取的数据
      this.spanArr = {};
      this.pos = 0;
      data.forEach(item => {
        item.list.forEach((items, indexs) => {
          if (indexs === 0) {
            // 如果是第一条记录（即索引是0的时候），向数组中加入１
            this.spanArr[items.cooperativeUnitId] = []
            this.spanArr[items.cooperativeUnitId].push(1);
            this.pos = 0;
          } else {
            if (items.cooperativeUnitId === item.list[indexs - 1].cooperativeUnitId) {
              // 如果itemCode相等就累加，并且push 0
              this.spanArr[items.cooperativeUnitId][this.pos] += 1;
              this.spanArr[items.cooperativeUnitId].push(0);
            } else {
              // 不相等push 1
              let same = false
              Object.keys(this.spanArr).forEach(spanItem => {
                if (spanItem == items.cooperativeUnitId) {
                  same = true
                }
              })
              if (!same) {
                this.spanArr[items.cooperativeUnitId] = []
              }
              // this.spanArr[items.cooperativeUnitId].push(1);
              this.spanArr[items.cooperativeUnitId][indexs] = 1;
              this.pos = indexs;
            }
          }
        })
        item.list.forEach((items, indexs) => {
          let key = items.receiveStationId + 'station' + items.cooperativeUnitId
          if (indexs === 0) {
            // 如果是第一条记录（即索引是0的时候），向数组中加入１
            this.spanArr[key] = []
            this.spanArr[key].push(1);
            this.pos = 0;
          } else {
            if (items.cooperativeUnitId === item.list[indexs - 1].cooperativeUnitId && items.receiveStationId === item.list[indexs - 1].receiveStationId) {
              // 如果itemCode相等就累加，并且push 0
              this.spanArr[key][this.pos] += 1;
              this.spanArr[key].push(0);
            } else {
              // 不相等push 1
              let same = false
              Object.keys(this.spanArr).forEach(spanItem => {
                if (spanItem == (key)) {
                  same = true
                }
              })
              if (!same) {
                this.spanArr[key] = []
              }
              // this.spanArr[items.receiveStationId].push(1);
              this.spanArr[key][indexs] = 1;
              this.pos = indexs;
            }
          }
        })
        item.list.forEach((items, indexs) => {
          let key = items.receiveStationId + 'station' + items.cooperativeUnitId + 'rawId' + items.rawId
          if (indexs === 0) {
            // 如果是第一条记录（即索引是0的时候），向数组中加入１
            this.spanArr[key] = []
            this.spanArr[key].push(1);
            this.pos = 0;
          } else {
            if (items.cooperativeUnitId === item.list[indexs - 1].cooperativeUnitId && items.receiveStationId === item.list[indexs - 1].receiveStationId && items.rawId === item.list[indexs - 1].rawId) {
              // 如果itemCode相等就累加，并且push 0
              this.spanArr[key][this.pos] += 1;
              this.spanArr[key].push(0);
            } else {
              // 不相等push 1
              let same = false
              Object.keys(this.spanArr).forEach(spanItem => {
                if (spanItem == key) {
                  same = true
                }
              })
              if (!same) {
                this.spanArr[key] = []
              }
              // this.spanArr[key].push(1);
              this.spanArr[key][indexs] = 1;
              this.pos = indexs;
            }
          }
        })
      })
      console.log(this.spanArr)
    },
    /*补差 */
    /**调整金额*/
    delItem1(index) {
      this.deductionList.splice(index, 1);
    },
    addItem1() {
      let obj = {
        cooperativeUnitId: this.billList[0].tranSupplierId,
        cooperativeUnit: this.billList[0].tranSupplier,
        stationId: "",
        station: "",
        deductionTypeId: "",
        deductionType: "",
        deduction: "",
        influenceInvoice: 0,
        remark: "",
        addOrReduce: "",
        rawId: "",
        rawName: "",
      };
      this.deductionList.push(obj);
    },
    downloadLink() {
      this.$Download(this.download, { statementNo: this.low.statementNo, dataType: 1 })
    },
    /**通过站点查询公司 */
    get_simple_organizationFun(id) {
      get_simple_organization({ id: id }).then((res) => {
        this.companyId = res.data.id
        this.company = res.data.name
      });//查询站点所属公司
    },
    /*根据公司获取站点*/
    setstationIdlist() {
      get_station_list({ parentId: this.fromDate.companyId }).then((res) => {
        this.stationIdlist = res.data;
      });
    },
    init() {
      this.tableData = []
      this.datePicker = []
      this.tableParam = this.$options.data().tableParam
      if (this.currenindex == 3) {
        this.tableParam.statementType = 1
        this.gettableData()
      } else {
        this.tableParam.carContractId = ''
        this.searchText = ''
        if (this.currenindex == 1) {
          this.tableParam['settlementStatusList'] = [0]
        }
        if (this.currenindex == 2) {
          this.tableParam['settlementStatusList'] = [1, 2]

        }
      }


    },
    /**结算合计*/
    settotalList: _debounce(function () {
      // let _this = this
      // _this.totalList = []
      // this.billList.forEach(res => {
      //   let index = _this.totalList.findIndex(item => (item.tranSupplier == res.tranSupplier))
      //   if (index == -1) {
      //     _this.totalList.push({ tranSupplier: res.tranSupplier, receiveNum: res.receiveNum, settlementAmount: res.settlementAmount })
      //   } else {
      //     _this.totalList[index].receiveNum = Number(res.receiveNum) + Number(_this.totalList[index].receiveNum)
      //     _this.totalList[index].settlementAmount = Number(Number(res.settlementAmount) + Number(_this.totalList[index].settlementAmount)).toFixed(2)
      //   }
      // })
      console.log('---------------------')
      let _this = this;
      let list = [];
      let totalList = [];
      let newtotalList = [];
      _this.billList.forEach(res => {
        list = list.concat(res.list);
      });
      let newsendersList = [];
      _this.sendersList.forEach(res => {
        let index = newsendersList.findIndex(item => item.cooperativeUnitId == res.cooperativeUnitId);
        if (index == -1) {
          newsendersList.push({ cooperativeUnitId: res.cooperativeUnitId, compensateAmount: res.compensateAmount });
        } else {
          newsendersList[index].realPay = (Number(res.compensateAmount) + Number(newsendersList[index].compensateAmount)).toFixed(2);
        }
      });
      list.forEach((res) => {
        let index = newtotalList.findIndex(item => item.tranSupplierId == res.tranSupplierId);
        let dealPrice = this.settleType == 0 ? res.dealPrice : res.settlementAmount
        if (index == -1) {
          newtotalList.push({
            tranSupplierId: res.tranSupplierId,
            tranSupplier: res.tranSupplier,
            settlementAmount: Math.round(parseFloat(Number(dealPrice) + Number(res.increaseAmount)) * 100) / 100,
            compensateAmount: null,
            realPay: Math.round(parseFloat(Number(dealPrice) + Number(res.increaseAmount)) * 100) / 100,
            faceAdjustment: Math.round(parseFloat(Number(dealPrice) + Number(res.increaseAmount)) * 100) / 100,
            statementNo: res.statementNo,
          });
        } else {
          newtotalList[index].settlementAmount = Math.round(parseFloat(Number(newtotalList[index].settlementAmount) + Number(dealPrice)) * 100) / 100;
          newtotalList[index].realPay = Math.round(parseFloat(Number(newtotalList[index].realPay) + Number(dealPrice) + Number(res.increaseAmount)) * 100) / 100;
          newtotalList[index].faceAdjustment = Math.round(parseFloat(Number(newtotalList[index].faceAdjustment) + Number(dealPrice) + Number(res.increaseAmount)) * 100) / 100;
        }
      });
      totalList = newtotalList.map(res => {
        let item1 = newsendersList.find(item => item.cooperativeUnitId == res.tranSupplierId);
        console.log(item1);
        // let item2 = this.deductionList.filter(item => item.cooperativeUnitId == res.tranSupplierId);
        // console.log(item2);
        const sum = (prev, cur) => prev + (cur.influenceInvoice == 1 ? (cur.addOrReduce == 0 ? (0 - Number(cur.deduction)) : Number(cur.deduction)) : 0);
        const sum2 = (prev, cur) => prev + (cur.addOrReduce == 0 ? (0 - Number(cur.deduction)) : Number(cur.deduction));
        let deduction = this.deductionList.reduce(sum2, 0);
        let deduction2 = this.deductionList.reduce(sum, 0);
        console.log(deduction);
        let obj = new Object();
        obj.compensateAmount = 0;
        if (item1) {
          obj.compensateAmount = Number(item1.compensateAmount).toFixed(2);
        }
        obj.tranSupplier = res.tranSupplier;
        obj.tranSupplierId = res.tranSupplierId;
        obj.faceAdjustment = Number(res.faceAdjustment * 1 + obj.compensateAmount * 1 + (deduction2 * 1 || 0.00)).toFixed(2);
        console.log(res.faceAdjustment, res.settlementAmount, obj.compensateAmount, deduction);
        obj.realPay = Number(res.realPay * 1 + obj.compensateAmount * 1 + (deduction * 1 || 0)).toFixed(2);
        obj.settlementAmount = res.settlementAmount;
        obj.receiveNum = res.receiveNum;
        console.log(obj.settlementAmount);
        obj.deduction = deduction || 0;
        obj.statementNo = null;
        return obj;
      });
      let totalList1 = _this.totalList.filter(res => res.localstatus);
      _this.totalList = [...totalList, ...totalList1];
      console.log(_this.totalList);
      console.log(_this.deductionList)
    }, 500),
    /**合计*/
    combined(arr) {
      let num = 0;
      arr.forEach(res => {
        if(this.settleType == 0) {
          num = Number(res.dealPrice) + Number(res.increaseAmount) + num;
        }
        if(this.settleType == 1) {
          num = Number(res.settlementAmount) + Number(res.increaseAmount) + num;
        }
      });
      return num.toFixed(2);
    },
    /**导航栏切换*/
    choose(pages) {
      this.pagesLoading = true
      this.currenindex = pages;
    },
    /**获取对应的搜搜添加*/
    getsearchData() {
      let _this = this
      if (_this.currenindex == 1 || _this.currenindex == 2) {
        get_contract_list({ supplerName: this.supplierNameSearch }).then(res => {
          _this.searchData = res.data
        })
      }
      // if (_this.currenindex == 2) {
      //   get_search_conditions().then(res => {
      //     _this.unitIdList = res.data.supplier
      //     _this.rawList = res.data.raw
      //   })
      //   console.log()
      // }
      if (_this.currenindex == 3) {
        get_supplier_list({ statementType: 1 }).then(res => {
          _this.unitIdList = res.data
        })
      }
    },
    /**合同列表选中*/
    setradio(data) {
      this.searchradio = JSON.stringify(data);
      this.companyId = data.firstPartyId;
      this.company = data.firstParty;
    },
    /**确定选择运输合同*/
    submitsearch() {
      let text = JSON.parse(this.searchradio);
      let arr = []
      arr.push(text.id)
      this.tableParam.carContractId = text.id
      this.stations = JSON.parse(text.stations);
      this.searchText = text.supplierName + '-' + text.id
      this.search = false
    },
    /**查询 */
    pagesgettableData() {
      if (this.tableParam.carContractId && this.datePicker && this.datePicker.length !== 0) {
        this.gettableData()
        return
      }
      this.$message({
        message: '警告哦，请先选择供应商和时间段后查询',
        type: 'warning'
      });
    },
    /**表格选中数据*/
    tableChange(val) {
      this.generate.originalList = val
    },
    /**生成结算单*/
    async statements() {
      this.deductionList = [];
      await generate_statement(this.generate).then(res => {
        this.billDetails = res.data
        this.settleType = res.data.settleMethod || 0
        this.billList = [];
        //结算信息--开始
        res.data.list.forEach(ress => {
          ress.statementNo = res.data.statementNo
          let index = this.billList.findIndex(item => item.tranSupplierId == ress.tranSupplierId && item.rawNameId == ress.rawNameId);
          if (index == -1) {
            let arr = [];
            arr.push(ress);
            this.billList.push({ tranSupplier: ress.tranSupplier, tranSupplierId: ress.tranSupplierId, rawName: ress.rawName, rawNameId: ress.rawNameId, list: arr });
          } else {
            this.billList[index].list.push(ress);
          }
        });
        //结算信息--完成
        console.log(JSON.parse(JSON.stringify(this.billList)));
        this.deductionList = res.data.deductionList;
        this.sendersList = [];
        this.rawMaterialsList = res.data.rawMaterialsList
      })
      let data = {
        contractId: this.tableParam.carContractId,
      };
      await generate_tansport_tatement_compensate(data).then(res2 => {
        if (res2.data) {
          let list2 = res2.data;
          this.senderDigList = list2
        }
      });
      this.billDeta = true
    },
    /**提交结算单*/
    combinedSubmit(type) {
      let self = this
      let data = new Object()
      if (self.companyId == '' && self.UserInfo.adminStatus == 1) {
        self.$message({
          message: '请选择公司',
          type: 'warning'
        });
        return
      }
      // if (self.stationId == '') {
      //   self.$message({
      //     message: '请选择站点',
      //     type: 'warning'
      //   });
      //   return
      // }
      new Promise(resolve => {
        html2canvas(self.$refs.html).then((canvas) => {
          canvas.toBlob((blob) => {
            const file = new File([blob], '结算截图.jpg', { type: 'image/jpg' });
            const params = new FormData();
            params.append('file', file);
            uploadFile(params).then(res => {
              if (res.code === 1001) {
                resolve(res.data.fileUrl)
              }
            })
          })
        })
      }).then(value => {
        let list = [];
        let total = 0;
        let total2 = 0;
        self.billList.forEach(res => {
          list = list.concat(res.list);
        });
        console.log(self.totalList);
        self.totalList.forEach(res => {
          total = total + Number(res.realPay);
          total2 = total2 + Number(res.faceAdjustment);
        });
        // if (total !== total2) {
        //   self.$message({
        //     message: "开票金额之和要等于实付金额之和",
        //     type: "warning",
        //   });
        //   return;
        // }
        data.list = list;
        let sendersListArr = [];
        self.sendersList.forEach(res => {
          res.list.forEach(res2 => {
            res2.detailId = res2.detailId.join(',')
          })
          sendersListArr = sendersListArr.concat(res.list);
        });
        data.picture = value;
        data.compensateList = sendersListArr;
        data.originalList = self.billDetails.originalList;
        // data.clearingSourceId = self.generate.clearingSourceId;
        data.statementNo = self.billDetails.statementNo;
        data.unitName = JSON.parse(self.searchradio).supplierName;
        data.unitId = JSON.parse(self.searchradio).supplierId;
        data.startTime = self.tableParam.startTime;
        data.endTime = self.tableParam.endTime;
        data.statementAmount = total; // 结算合计，合计
        data.operation = 0; //0：保存，1：提交审核
        data.auditStatus = 1; //0：保存，1：提交审核
        data.submitTime = new Date().Format("yyyy-MM-dd hh:mm:ss"); // 提交审核时间
        data.contractId = self.tableParam.carContractId;
        //data.contractNo = self.tableParam.contractNo;
        data.deductionList = self.deductionList;
        data.company = self.company;
        data.companyId = self.companyId;
        data.total = self.totalList[0];
        console.log(data)
        save_or_update_detail(data).then(res => {
          if (res.code == 1001) {
            self.billDeta = false
            if (type == 2) {
              self.$router.push({ name: "sign_Wise_rentunit1", query: { id: res.data, type: 1 } });
              return
            }
            self.$message({
              message: "保存成功",
              type: "success",
            });
            self.gettableData()
          }
        })
      })
    },
    /**修改结算单 */
    combinedSubmit_3() {
      let self = this;
      new Promise(resolve => {
        html2canvas(self.$refs.html).then(canvas => {
          canvas.toBlob(blob => {
            const file = new File([blob], "结算截图.jpg", { type: "image/jpg" });
            const params = new FormData();
            params.append("file", file);
            uploadFile(params).then(res => {
              if (res.code === 1001) {
                resolve(res.data.fileUrl);
              }
            });
          });
        });
      }).then(value => {
        let list = [];
        let total = 0;
        let total2 = 0;
        self.billList.forEach(res => {
          list = list.concat(res.list);
        });
        console.log(self.totalList);
        self.totalList.forEach(res => {
          total = total + Number(res.realPay);
          total2 = total2 + Number(res.faceAdjustment);
        });
        // if (total !== total2) {
        //   self.$message({
        //     message: "开票金额之和要等于实付金额之和",
        //     type: "warning",
        //   });
        //   return;
        // }
        let form = {};
        form = self.billDetails1;
        form.list = list;
        let compensateList = [];
        self.sendersList.forEach(res => {
          res.list.forEach(res2 => {
            res2.detailId = res2.detailId.join(',')
          })
          compensateList = compensateList.concat(res.list);
        });
        form.compensateList = compensateList;
        form.picture = value;
        // //调整金额 数据处理开始
        // let deductionList = [];
        // let update = self.deductionList.filter(res => self.deductionListCopy.some(item => res.id == item.id));
        // let deleteData = self.deductionListCopy.filter(res => !update.some(item => res.id == item.id));
        // deleteData.forEach(res => {
        //   res.status = 0; //0是删除
        // });
        // let addData = self.deductionList.filter(
        //   //新增的type默认写死为 1
        //   res => !update.some(item => res.id == item.id)
        // );
        // deductionList = [...update, ...deleteData, ...addData];
        // form.deductionList = deductionList;
        // //调整金额 数据处理结束
        form.deductionList = self.deductionList;
        form.total = self.totalList[0];
        form.operation = 0;
        form.statementAmount = total; // 结算合计，合计
        update_statement(form).then(res => {
          if (res.code == 1001) {
            self.billDeta1 = false;
            self.$message({
              message: "保存成功",
              type: "success",
            });
            self.gettableData();
          }
        });
      });
    },
    show(low) {
      this.low = low
      get_statement_detail({ statementNo: low.statementNo, mark: 1 }).then(async res => {
        if (res.code == 1001) {
          this.billDetails1 = res.data
          this.settleType = res.data.settleMethod || 0
          this.stations = JSON.parse(res.data.stations);
          this.billList = []
          res.data.list.forEach(res => {
            let index = this.billList.findIndex(item => item.tranSupplierId == res.tranSupplierId && item.rawNameId == res.rawNameId);
            if (index == -1) {
              let arr = [];
              arr.push(res);
              this.billList.push({ tranSupplier: res.tranSupplier, tranSupplierId: res.tranSupplierId, rawName: res.rawName, rawNameId: res.rawNameId, list: arr });
            } else {
              this.billList[index].list.push(res);
            }
          });
          console.log(JSON.parse(JSON.stringify(this.billList)));
          //调整金额
          this.deductionList = []
          this.deductionList = res.data.deductionList || [];
          this.deductionListCopy = JSON.parse(JSON.stringify(res.data.deductionList || []));
          //补差
          this.sendersList = [];
          let list2 = this.billDetails1.compensateList || [];
          list2.forEach(val => {
            val.detailId = val.detailId.split(',')
            let index = this.sendersList.findIndex(item => item.cooperativeUnitId == val.cooperativeUnitId);
            if (index == -1) {
              let arr = [];
              arr.push(val);
              this.sendersList.push({ cooperativeUnit: val.cooperativeUnit, cooperativeUnitId: val.cooperativeUnitId, list: arr });
            } else {
              this.sendersList[index].list.push(val);
            }
          });
          console.log(this.sendersList)
          this.getSpanArr(this.sendersList)
          //补差列表
          let data = {
            logisticsList: res.data.logisticsList,
            contractId: this.low.contractId,
            clearingSourceId: this.low.clearingSourceId,
            statementNo: this.low.statementNo
          };
          await generate_tansport_tatement_compensate(data).then(res2 => {
            if (res2.data) {
              let list2 = res2.data;
              this.senderDigList = list2

            }
          });
          this.rawMaterialsList = res.data.rawMaterialsList
          this.billDeta1 = true
        }
      })
    },
    /**结算单发给供应商*/
    // send(low) {
    //   this.low = low
    //   this.userarr = []
    //   this.useroptons = []
    //   queryUserByID({ id: low.contractId }).then(res => {
    //     this.useroptons = JSON.parse(res.data)
    //     this.userDeta = true
    //   })
    // },
    async userSubmit(low) {
      this.$confirm('确认发送?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        cancelButtonClass: 'bottom_all_two',
        confirmButtonClass: 'bottom_all',
        type: 'warning'
      }).then(async () => {
        let json = {
          contractId: low.contractId,
          type: 4,
          settlementId: low.id,
          settlementNo: low.statementNo,
          times: low.startTime + '-' + low.endTime,
          money: low.statementAmount,
          applyForTime: low.submitTime,
          imgUrl: low.picture,
        }
        // let arr = this.userarr.map(res => (new useritem(res)))
        await informClient(json).then(res => {
          if (res.code == 1001) {
            update_status({
              statementNo: low.statementNo,
              supplierConfirm: 1,
              statusType: 2,
            }).then(() => { })
            this.$message({
              message: '发送成功',
              type: 'success'
            });
            this.gettableData()
            this.userDeta = false
          }
        })
      })
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      if (this.currenindex == 1) {
        this.pagesgettableData()
      } else {
        this.gettableData();
      }
    },
    changeSizes() {
      this.tableParam.pageSize = this.curElPage;
      if (this.currenindex !== 3) {
        this.pagesgettableData();
      } else {
        this.gettableData();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dialoginfo {
  padding: 20px 20px 0 20px;
  max-height: 400px;
  overflow: auto;
}

.tabtop {
  width: 571px;
}

.el-input,
.el-select {
  width: 240px;
}

/*
 <el-link class="table_link" :underline="false">查看配合比</el-link>*/
.table_link {
  margin: 0 10px;
  color: $bg_color;
  cursor: pointer;
}

.table_link:hover {
  opacity: 0.8;
}

.bill_top {
  display: flex;
  justify-content: space-between;
  line-height: 40px;
  flex-wrap: wrap;

  .text {
    font-weight: 600;
    color: #000;
  }
}

.bill_title {
  font-size: 18px;
  font-weight: 600;
  padding: 15px 0;
}

.bill_title1 {
  font-size: 18px;
  font-weight: 600;
  padding: 20px 0;
}

.bill_subtitle {
  padding: 20px 0;

  >span {
    padding-right: 20px;
  }

  .text {
    color: #000;
  }
}

.combined {
  border: 1px solid #ebeef5;
  text-align: center;
  line-height: 40px;
}
</style>
